<script lang="ts">
  import { link, push } from 'svelte-spa-router';
  import { currentUser, authReady } from '$lib/stores/auth';
  // Logged-in only; the frozen page itself is served behind auth by the API.
  $: if ($authReady && !$currentUser) push('/login');
</script>

<div class="results">
  <header>
    <a href="/map" use:link>← Map</a>
    <span>HD51 election-night results</span>
    <a href="/api/results/hd51" target="_blank" rel="noopener">Open full page</a>
  </header>
  {#if $currentUser}
    <iframe src="/api/results/hd51" title="HD51 election-night results"></iframe>
  {/if}
</div>

<style>
  .results { position: fixed; inset: 0; display: flex; flex-direction: column; background: var(--paper); }
  header {
    display: flex; align-items: center; justify-content: space-between; gap: 12px;
    padding: 10px 16px; background: var(--ink); color: var(--paper);
    font-family: var(--font-body); font-size: 0.85rem;
  }
  header a { color: var(--paper); text-decoration: none; font-weight: 600; }
  iframe { flex: 1; width: 100%; border: 0; }
</style>
